import { Exam } from "./Exam";

export class Admission {
    id!:string;
    name!:string;
    cf!:string;
    degree_type!:string;
    exam_vote!:number;
    languageLevel!:string;
    inserted_at!:string;
    updated_at!:string;
    exams: Exam[] = [];
    new_file_name!:string;
    examsAverage: number | null = null
}